import { productVariantsContracts } from "./product-variants.contract";
import { warehousesContracts } from "./warehouses.contract";
import { warehouseHierarchyContracts } from "./warehouse-hierarchy.contract";
import { productsContracts } from "./products.contract";
import { productMarginsContracts } from "./product-margins.contract";
import { productCatalogContracts } from "./product-catalog.contract";
import { transferOrdersContracts } from "./transfer-orders.contract";
import { pricelistContracts } from "./pricelist.contract";

export const inventoryManagementContracts = {
  productVariants: productVariantsContracts,
  warehouses: warehousesContracts,
  warehouseHierarchy: warehouseHierarchyContracts,
  products: productsContracts,
  productMargins: productMarginsContracts,
  productCatalog: productCatalogContracts,
  transferOrders: transferOrdersContracts,
  pricelist: pricelistContracts,
} as const;

export * from "./product-variants.contract";
export * from "./warehouses.contract";
export * from "./warehouse-hierarchy.contract";
export * from "./products.contract";
export * from "./product-margins.contract";
export * from "./product-catalog.contract";
export * from "./transfer-orders.contract";
export * from "./pricelist.contract";
